import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=4f881593"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f881593')) {
      api.createRecord('4f881593', component.options)
    } else {
      api.reload('4f881593', component.options)
    }
    module.hot.accept("./Quiz.vue?vue&type=template&id=4f881593", function () {
      api.rerender('4f881593', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/Quiz.vue"
export default component.exports